import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs } from '@redux-devtools/ui';
import { monitors } from '../utils/getMonitor.js';
import { selectMonitor } from '../actions/index.js';
class MonitorSelector extends Component {
    shouldComponentUpdate(nextProps) {
        return nextProps.selected !== this.props.selected;
    }
    render() {
        return (React.createElement(Tabs, { main: true, collapsible: true, position: "center", tabs: monitors, onClick: this.props.selectMonitor, selected: this.props.selected || 'InspectorMonitor' }));
    }
}
const mapStateToProps = (state) => ({
    selected: state.monitor.selected,
});
const actionCreators = {
    selectMonitor,
};
export default connect(mapStateToProps, actionCreators)(MonitorSelector);
